import { AtomErrors } from "./AtomErrors";
import { InternalErrors } from "./InternalErrors";

export type FrameworkErrorKey = AtomErrors | InternalErrors;

function toIdentityCodeMap<T extends string>(
  values: readonly T[],
): Record<T, string> {
  return Object.fromEntries(
    values.map((value) => [value, value]),
  ) as unknown as Record<T, string>;
}

/**
 * Flat compatibility surface for callers that still want a lookup object even
 * though the enum values themselves are already the canonical codes.
 */
export const frameworkErrorCodeMap: Record<FrameworkErrorKey, string> = {
  ...toIdentityCodeMap(Object.values(AtomErrors)),
  ...toIdentityCodeMap(Object.values(InternalErrors)),
};

/**
 * Backwards-compatible alias for the pre-refactor flat map.
 */
export const errorCodeMap = frameworkErrorCodeMap;

export function getFrameworkErrorCode(key: FrameworkErrorKey): string {
  return key;
}
